import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [{
  name: 'main',
  path: '/',
  component: () => import('@/components/Main'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
},{
  name: 'contactus',
  path: '/contactus',
  component: () => import('@/components/ContactUs'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
}, {
  name: 'beaver',
  path: '/beaver',
  component: () => import('@/components/Beaver'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
}, {
  name: 'borrowedtime',
  path: '/borrowedtime',
  component: () => import('@/components/BorrowedTime'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
}, {
  name: 'horsefeathers',
  path: '/horsefeathers',
  component: () => import('@/components/HorseFeathers'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
}, {
  name: 'horsenest',
  path: '/horsenest',
  component: () => import('@/components/HorseNest'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
}, {
  name: 'fox',
  path: '/fox',
  component: () => import('@/components/Fox'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
}, {
  name: 'bear',
  path: '/bear',
  component: () => import('@/components/Bear'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
}, {
  name: 'coyote',
  path: '/coyote',
  component: () => import('@/components/Coyote'),
  meta: {
    // title: `${applicationName} - Login`,
    requiresAuth: false
  }
},
{
  path: '*',
  redirect: '/'
}];

const router = new Router({
  mode: 'history',
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js